// Composer mode + panel width for the counsel side panel, persisted in
// localStorage. Both are per agent (not per conversation): they describe how
// this person likes to work with the AI across every conversation they open.
const MODE_STORAGE_PREFIX = 'counsel_mode';
const WIDTH_STORAGE_PREFIX = 'counsel_panel_width';

export const MODE_ASK = 'ask';
export const MODE_AGENT = 'agent';
export const MODES = Object.freeze([MODE_ASK, MODE_AGENT]);
export const DEFAULT_MODE = MODE_ASK;

// Desktop panel width (px). Mobile keeps a full-screen overlay and ignores this.
export const DEFAULT_PANEL_WIDTH = 420;
export const MIN_PANEL_WIDTH = 320;
export const MAX_PANEL_WIDTH = 900;
// Leave at least this much room for the main conversation column while dragging.
export const MIN_MAIN_COLUMN_WIDTH = 360;

const modeKey = userId => `${MODE_STORAGE_PREFIX}:${userId || 'anonymous'}`;
const widthKey = userId => `${WIDTH_STORAGE_PREFIX}:${userId || 'anonymous'}`;

export const loadMode = userId => {
  try {
    const raw = window.localStorage.getItem(modeKey(userId));
    return MODES.includes(raw) ? raw : DEFAULT_MODE;
  } catch (err) {
    return DEFAULT_MODE;
  }
};

export const saveMode = (userId, mode) => {
  if (!MODES.includes(mode)) return;
  try {
    window.localStorage.setItem(modeKey(userId), mode);
  } catch (err) {
    // localStorage may be disabled or quota exceeded; fail silently.
  }
};

const clampWidth = (value, windowWidth = 0) => {
  let max = MAX_PANEL_WIDTH;
  if (windowWidth > 0) {
    max = Math.min(MAX_PANEL_WIDTH, Math.max(MIN_PANEL_WIDTH, windowWidth - MIN_MAIN_COLUMN_WIDTH));
  }
  const n = Number(value);
  if (!Number.isFinite(n)) return DEFAULT_PANEL_WIDTH;
  return Math.min(max, Math.max(MIN_PANEL_WIDTH, Math.round(n)));
};

export const loadPanelWidth = (userId, windowWidth = 0) => {
  try {
    const raw = window.localStorage.getItem(widthKey(userId));
    return clampWidth(raw, windowWidth);
  } catch (err) {
    return clampWidth(DEFAULT_PANEL_WIDTH, windowWidth);
  }
};

export const savePanelWidth = (userId, width, windowWidth = 0) => {
  try {
    window.localStorage.setItem(
      widthKey(userId),
      String(clampWidth(width, windowWidth))
    );
  } catch (err) {
    // localStorage may be disabled or quota exceeded; fail silently.
  }
};

export { clampWidth };
